import type { OrganizationState } from '../../types';

export function partnerNamesAsText(item: { partners?: string[] }, o: OrganizationState): string {
  if (item.partners === undefined) return 'Ingen';
  const a = item.partners
    .map(function (id) {
      return o.partnersById[id];
    })
    .filter(function (e) {
      return e && !e.deleted;
    })
    .map(function (e) {
      return e.name;
    })
    .sort();

  if (a.length === 0) {
    return 'Ingen';
  } else {
    return a.join(', ');
  }
}
